import React from 'react';
import { Skeleton } from 'lib/cortiUI';
export const ComparisonLoader = () => {
    return React.createElement(Skeleton, { variant: "text", width: 150, height: 25 });
};
